module.exports = __webpack_public_path__ + "assets/img/select_on_image_radio_right.svg";